class Footer extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <section
                className='section footer'
                id='footer'>

                <div className='row'>

                    <hr />

                    <div className='footer__info'>
                        <div className="footer__logo" />

                        <p>{this.props.content.text}</p>
                    </div>

                </div>

            </section>
        );
    }
}

export default Footer;


/*
                    <ul className='social-links'>
                        <li><a href='#'><i className='fa fa-facebook-square'></i></a></li>
                        <li><a href='#'><i className='fa fa-twitter-square'></i></a></li>
                        <li><a href='#'><i className='fa fa-google-plus-square'></i></a></li>
                        <li><a href='#'><i className='fa fa-youtube-play'></i></a></li>
                        <li><a href='#'><i className='fa fa-vimeo-square'></i></a></li>
                        <li><a href='#'><i className='fa fa-flickr'></i></a></li>
                        <li><a href='#'><i className='fa fa-skype'></i></a></li>
                    </ul>
*/



// WEBPACK FOOTER //
// ./ui_src/app/components/footer/Footer.react.jsx